import {
	ShiftInterface,
	UpdateWorkMonitor,
	ResolveIncidentDto,
	WorkMonitorInterface,
	IncidentReportInterface,
	UpdateMultipleWorkMonitor,
	IncidentInterface,
} from "@type/workMonitor.types"
import axios from "axios"

const ROOT_PATH = "/shifts"
const TEMP_ROOT_PATH = "/schedules"

export default class WorkMonitorShifts {
	static getScheduleShiftEvents = (scheduleId: string) =>
		axios.get<ShiftInterface[]>(`${ROOT_PATH}/shift-events-by-schedule/${scheduleId}`)

	static getScheduleIncidents = (scheduleId: string) =>
		axios.get<IncidentReportInterface[]>(`${ROOT_PATH}/incidents-by-schedule/${scheduleId}`)

	static getShifts = (
		{
			startTime = "2022-05-02T00:00:00Z",
			finishTime = "2022-05-08T00:00:00Z",
			shiftIdsToExclude = [],
			isActive,
		}: WorkMonitorInterface,
		signal?: AbortSignal,
	) => {
		return axios.post<ShiftInterface[]>(`${ROOT_PATH}`, {
			startTime,
			finishTime,
			shiftIdsToExclude,
			isActive,
			signal,
		})
	}

	static getActiveShifts = () => {
		return axios.post<ShiftInterface[]>(`${ROOT_PATH}/active`)
	}

	static updateShifts = (shiftId: string, data: UpdateWorkMonitor) =>
		axios.put(`${ROOT_PATH}/add-event/${shiftId}`, data)

	static addIncidentInShift = (shiftId: string, body: IncidentReportInterface) =>
		axios.put<IncidentInterface>(`${TEMP_ROOT_PATH}/incident/${shiftId}`, body)

	static resolveIncidentInShift = (incidentId: string, body: ResolveIncidentDto) =>
		axios.put<IncidentInterface>(`${TEMP_ROOT_PATH}/resolve-incident/${incidentId}`, body)

	static updateMultipleShifts = (data: UpdateMultipleWorkMonitor[]) =>
		axios.put(`${ROOT_PATH}/add-multiple-event`, data)
}
